// Widget-Plugin: Icon
// Widget-Plugin: List
vcDashboardRegistry.register("list", {
    defaults: { w: 8, h: 4, resizable: true, copyable: true },
    settingsDefaults: { SignalId: 4 },
    render: function ($container, item) {
        var title = item.name || item.title || vcDashboardResources.get("list");
        $container.html(
            "<div class='dashboard-list-wrapper'>" +
                "<div class='dashboard-list-title'>" + title + "</div>" +
                "<div class='dashboard-list-content'></div>" +
            "</div>"
        );
    },
    init: function ($item, settings) {
    }
});
